import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function PaymentSuccessArtist() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard after 5 seconds
    const timer = setTimeout(() => {
      navigate('/artist/dashboard');
    }, 5000);
    
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-600 to-purple-800"
    >
      <div className="text-center">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
        >
          <CheckCircle size={80} className="text-green-400 mx-auto mb-6" />
        </motion.div>
        
        <h1 className="text-4xl font-bold text-white mb-4">
          Subscription Active!
        </h1>
        
        <p className="text-xl text-gray-100 mb-8">
          Welcome to The Asidors Artist Membership. Enjoy unlimited uploads, analytics, and more!
        </p>
        
        <div className="bg-white bg-opacity-10 backdrop-blur rounded-lg p-6 max-w-md mx-auto mb-8">
          <h3 className="text-white font-semibold mb-4">Your Benefits:</h3>
          <ul className="text-left text-gray-100 space-y-2">
            <li>✓ Upload unlimited songs</li>
            <li>✓ View detailed analytics</li>
            <li>✓ Featured artist status</li>
            <li>✓ Monthly royalty reports</li>
          </ul>
        </div>
        
        <button
          onClick={() => navigate('/artist/dashboard')}
          className="px-6 py-3 bg-white text-purple-600 rounded-lg font-semibold hover:bg-gray-100 transition"
        >
          Go to Dashboard
        </button>
      </div>
    </motion.div>
  );
};